<ng-container *ngIf="!empresaStatus">
  <div class="onboarding-empresa__container">
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  </div>
</ng-container>

<ng-container *ngIf="empresaStatus">
  <div class="onboarding-empresa__container">
    <app-onboarding-card
      imageUrl="../../../../../assets/images/worker.png"
      title="Cargo"
      redirectTo="/estrutura-organizacional/cargo"
      [checked]="empresaStatus.cargo"
    ></app-onboarding-card>

    <app-onboarding-card
      imageUrl="../../../../../assets/images/management.png"
      title="Departamento"
      redirectTo="/estrutura-organizacional/departamento"
      [checked]="empresaStatus.departamento"
    ></app-onboarding-card>

    <app-onboarding-card
      imageUrl="../../../../../assets/images/budget.png"
      title="Centro de Custo"
      redirectTo="/estrutura-organizacional/centro-de-custo"
      [checked]="empresaStatus.centroDeCusto"
    ></app-onboarding-card>
  </div>

  <div class="d-flex justify-content-end">
    <button mat-flat-button color="primary" (click)="onNextClick()">
      Próximo
    </button>
  </div>
</ng-container>
